<template>
  <div class="dashboard-wrapper" :class="{'sidebar-open': sideOpen, 'side-modal-open': sideModalOpen}">
    <dashboard-sidebar></dashboard-sidebar>
    <transition name="slide-to-left">
      <side-modal v-if="sideModalOpen"></side-modal>
    </transition>
    <transition name="fade">
      <sidebar-overlay v-if="sideOpen || sideModalOpen"></sidebar-overlay>
    </transition>
    <main>
      <dashboard-header></dashboard-header>
      <div class="dashboard-content">
        <div class="page-header mb-20 pl-20">
          <div class="row">
            <div class="col-sm-6">
              <h3 class="page-title">Transactions</h3>
            </div>
            <div class="col-sm-6">
              <div class="screen-controls"></div>
            </div>
          </div>
        </div>
        <div class="kp-flat-card small-shadow">
          <div class="table-controls mb-20">
            <div class="form-row align-items-center">
              <div class="col-lg-5 col-xl-3">
                <div class="form-group with-icon ml-0 ml-sm-50">
                  <i class="uil uil-search"></i>
                  <div class="input-wrapper">
                    <input v-floating-label id="yearlyTurnover" name="yearlyTurnover" v-model="searchTransactions" type="text" class="form-control" />
                    <label for="yearlyTurnover">Search/filter transactions</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-table ref="transactionsTable" :data="tablePagedData" layout="table" highlight-current-row @current-change="handleCurrentChangeTable" :default-sort="{prop: 'date', order: 'descending'}">
            <el-table-column type="index" :index="calculateIndex" width="50"></el-table-column>
            <el-table-column :prop="titles[0].prop" :label="titles[0].label" :key="titles[0].label" :width="titles[0].width" :sortable="titles[0].sortable"></el-table-column>
            <el-table-column :prop="titles[1].prop" :label="titles[1].label" :key="titles[1].label" :width="titles[1].width" :sortable="titles[1].sortable" :formatter="formatDate"></el-table-column>
            <el-table-column :prop="titles[2].prop" :label="titles[2].label" :key="titles[2].label" :width="titles[2].width" :sortable="titles[2].sortable"></el-table-column>
            <el-table-column :prop="titles[3].prop" :label="titles[3].label" :key="titles[3].label" :width="titles[3].width" :sortable="titles[3].sortable" align="center">
              <template slot-scope="scope">
                <img :src="`./img/payments/${scope.row.paymentMethod}.png`" :alt="scope.row.paymentMethod" :style="{maxWidth: '50px'}" />
              </template>
            </el-table-column>
            <el-table-column :prop="titles[4].prop" :label="titles[4].label" :key="titles[4].label" :width="titles[4].width" :sortable="titles[4].sortable"></el-table-column>
            <el-table-column :prop="titles[5].prop" :label="titles[5].label" :key="titles[5].label" :width="titles[5].width" :sortable="titles[5].sortable"></el-table-column>
            <el-table-column :prop="titles[6].prop" :label="titles[6].label" :key="titles[6].label" :width="titles[6].width" :sortable="titles[6].sortable"></el-table-column>
          </el-table>
          <div class="mt-30">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="paginationOptions.currentPage"
              :page-size="paginationOptions.pageSize"
              layout="total, prev, pager, next"
              :total="tableData.length"
            ></el-pagination>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import moment from 'moment'
import { mapFields } from 'vuex-map-fields'
import DashboardHeader from '@/components/dashboard/DashboardHeader.vue'
import DashboardSidebar from '@/components/dashboard/DashboardSidebar.vue'
import SidebarOverlay from '@/components/dashboard/SidebarOverlay.vue'
import SideModal from '@/components/dashboard/SideModal.vue'
import transactionsData from '@/data/transactions.json'

export default {
  computed: {
    ...mapFields({
      user: 'user',
      sideOpen: 'ui.dashSideOpen',
      sideModalOpen: 'ui.sideModalOpen'
    }),
    tablePagedData() {
      const firstElem = (this.paginationOptions.currentPage - 1) * this.paginationOptions.pageSize
      const lastElem = firstElem + this.paginationOptions.pageSize
      const filteredData = this.tableData.slice(firstElem, lastElem)
      return filteredData
    }
  },
  components: {
    DashboardHeader,
    DashboardSidebar,
    SideModal,
    SidebarOverlay
  },
  data() {
    return {
      tableData: transactionsData,
      paginatedData: null,
      paginationOptions: {
        pageSize: 20,
        currentPage: 1
      },
      currentRow: null,
      checked: false,
      searchTransactions: '',
      tableActions: [
        {
          value: 'Option1',
          label: 'Option1'
        },
        {
          value: 'Option2',
          label: 'Option2'
        },
        {
          value: 'Option3',
          label: 'Option3'
        },
        {
          value: 'Option4',
          label: 'Option4'
        },
        {
          value: 'Option5',
          label: 'Option5'
        }
      ],
      titles: [
        {
          prop: 'transactionId',
          label: 'Transaction ID',
          width: '180px',
          sortable: true
        },
        {
          prop: 'date',
          label: 'Date',
          width: '120px',
          sortable: true
        },
        {
          prop: 'sender',
          label: 'Sender'
        },
        {
          prop: 'paymentMethod',
          label: 'Payment method'
        },
        {
          prop: 'recipient',
          label: 'Recipient'
        },
        {
          prop: 'invoiceRef',
          label: 'Invoice Ref.',
          width: '180px',
          sortable: true
        },
        {
          prop: 'amount',
          label: 'Amount',
          width: '150px',
          sortable: true
        }
      ]
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.paginationOptions.currentPage = val
    },
    handleCurrentChangeTable(val) {
      if (val) {
        this.currentRow = val
        val.title = 'Transaction'
        this.$store.commit('showHideSideModal', {
          show: true,
          component: 'single-transaction-modal',
          payload: val
        })
      }
    },
    clearTableSelection(newValue, oldValue) {
      if (!newValue) {
        this.currentRow = null
        this.$refs.transactionsTable.setCurrentRow()
      }
    },
    calculateIndex(index) {
      return (this.paginationOptions.currentPage - 1) * this.paginationOptions.pageSize + index + 1
    },
    formatDate(row, column, cellValue, index) {
      return moment(row.date).format('DD.MM.YYYY')
    }
  },
  mounted() {
    this.$store.watch(
      () => this.$store.state.ui.sideModalOpen,
      (newValue, oldValue) => this.clearTableSelection(newValue, oldValue),
      {
        deep: true
      }
    )
  }
}
</script>
